import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-white dark:bg-gradient-to-br dark:from-[#1a1a1a] dark:to-[#0c0c0c] p-4 md:p-6" }
const _hoisted_2 = { class: "max-w-7xl mx-auto space-y-8" }
const _hoisted_3 = { class: "bg-white dark:bg-[#1a1a1a] rounded-3xl shadow-xl border border-[#E5E7EB] dark:border-[#374151] overflow-hidden" }
const _hoisted_4 = { class: "bg-gradient-to-r from-[#007AFF] to-[#5856D6] dark:from-[#0056CC] dark:to-[#4338CA] p-6" }
const _hoisted_5 = { class: "flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4" }
const _hoisted_6 = { class: "flex items-center gap-4" }
const _hoisted_7 = { class: "text-left" }
const _hoisted_8 = { class: "text-2xl font-bold text-white" }
const _hoisted_9 = { class: "text-white" }
const _hoisted_10 = { class: "flex items-center gap-4" }
const _hoisted_11 = { class: "p-6" }
const _hoisted_12 = { class: "mb-6" }
const _hoisted_13 = { class: "relative max-w-md" }
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = {
  key: 0,
  class: "flex justify-center items-center py-16"
}
const _hoisted_16 = {
  key: 1,
  class: "flex flex-col justify-center items-center py-16"
}
const _hoisted_17 = { class: "text-xl font-semibold text-[#1a1a1a] dark:text-white mb-4" }
const _hoisted_18 = {
  key: 2,
  class: "bg-white dark:bg-[#1a1a1a] rounded-2xl overflow-hidden border border-[#E5E7EB] dark:border-[#374151]"
}
const _hoisted_19 = { class: "overflow-x-auto" }
const _hoisted_20 = { class: "w-full" }
const _hoisted_21 = { class: "bg-gradient-to-r from-[#007AFF] to-[#5856D6] dark:from-[#0056CC] dark:to-[#4338CA]" }
const _hoisted_22 = { class: "px-6 py-4 text-left text-white font-semibold" }
const _hoisted_23 = { class: "px-6 py-4 text-center text-white font-semibold" }
const _hoisted_24 = { class: "px-6 py-4 text-left text-white font-semibold" }
const _hoisted_25 = { class: "px-6 py-4 text-left text-white font-semibold" }
const _hoisted_26 = { class: "px-6 py-4 text-left text-white font-semibold" }
const _hoisted_27 = { class: "px-6 py-4 text-left text-white font-semibold" }
const _hoisted_28 = { class: "px-6 py-4 text-left text-white font-semibold" }
const _hoisted_29 = { class: "px-6 py-4" }
const _hoisted_30 = { class: "flex items-center" }
const _hoisted_31 = { class: "text-sm font-medium text-[#666666] dark:text-[#cccccc]" }
const _hoisted_32 = { class: "px-6 py-4 text-center" }
const _hoisted_33 = { class: "font-semibold text-[#1a1a1a] dark:text-white" }
const _hoisted_34 = {
  key: 0,
  class: "text-sm text-[#666666] dark:text-[#cccccc] truncate max-w-xs"
}
const _hoisted_35 = { class: "px-6 py-4" }
const _hoisted_36 = { class: "font-medium text-[#1a1a1a] dark:text-white" }
const _hoisted_37 = {
  key: 0,
  class: "text-sm text-[#666666] dark:text-[#cccccc]"
}
const _hoisted_38 = { class: "px-6 py-4" }
const _hoisted_39 = { class: "font-bold text-lg text-[#34C759]" }
const _hoisted_40 = { class: "px-6 py-4" }
const _hoisted_41 = { class: "text-[#1a1a1a] dark:text-white font-medium" }
const _hoisted_42 = { class: "px-6 py-4" }
const _hoisted_43 = { class: "px-6 py-4" }
const _hoisted_44 = { class: "flex items-center gap-2" }
const _hoisted_45 = ["title", "onClick"]
const _hoisted_46 = ["title", "onClick"]
const _hoisted_47 = ["title", "onClick"]
const _hoisted_48 = { class: "border-t border-[#E5E7EB] dark:border-[#374151] bg-white dark:bg-[#0c0c0c]" }
const _hoisted_49 = {
  key: 0,
  class: "fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50"
}
const _hoisted_50 = { class: "bg-white dark:bg-[#1a1a1a] rounded-3xl shadow-2xl border border-[#E5E7EB] dark:border-[#374151] max-w-md w-full mx-4 overflow-hidden" }
const _hoisted_51 = { class: "bg-gradient-to-r from-[#FF3B30] to-[#FF2D92] p-6" }
const _hoisted_52 = { class: "flex items-center gap-4" }
const _hoisted_53 = { class: "text-xl font-bold text-white" }
const _hoisted_54 = { class: "text-white/80 text-sm" }
const _hoisted_55 = { class: "p-6" }
const _hoisted_56 = { class: "text-[#1a1a1a] dark:text-white text-center mb-6" }
const _hoisted_57 = { class: "flex gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.directT('crm.deals.dealsManagement')), 1),
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.directT('crm.deals.manageDealsSubtitle')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_router_link, {
                to: "/crm/deals/create",
                class: "inline-flex items-center px-6 py-3 rounded-2xl bg-white/20 dark:bg-black/20 backdrop-blur-sm border border-white/30 dark:border-white/20 text-white font-medium hover:bg-white/30 dark:hover:bg-black/30 transition-all duration-200 shadow-lg"
              }, {
                default: _withCtx(() => [
                  _cache[3] || (_cache[3] = _createElementVNode("i", { class: "ri-add-line text-xl mr-2" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.directT('crm.deals.addNewDeal')), 1)
                ]),
                _: 1,
                __: [3]
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" }, [
                _createElementVNode("i", { class: "ri-search-line text-[#666666] dark:text-[#cccccc] text-xl" })
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
                placeholder: _ctx.directT('crm.deals.searchDeal'),
                class: "w-full h-12 pl-12 pr-4 rounded-2xl bg-white dark:bg-[#2a2a2a] border border-[#E5E7EB] dark:border-[#374151] text-[#1a1a1a] dark:text-white placeholder-[#666666] dark:placeholder-[#cccccc] focus:outline-none focus:ring-2 focus:ring-[#007AFF]/50 focus:border-[#007AFF] transition-all duration-200"
              }, null, 8, _hoisted_14), [
                [_vModelText, _ctx.searchTerm]
              ])
            ])
          ]),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[5] || (_cache[5] = [
                _createElementVNode("div", { class: "relative" }, [
                  _createElementVNode("div", { class: "w-16 h-16 border-4 border-[#007AFF]/30 border-t-[#007AFF] rounded-full animate-spin" }),
                  _createElementVNode("div", {
                    class: "absolute inset-0 w-16 h-16 border-4 border-transparent border-r-[#34C759] rounded-full animate-spin",
                    style: {"animation-delay":"-0.3s"}
                  })
                ], -1)
              ])))
            : (_ctx.deals.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "w-24 h-24 bg-gradient-to-br from-[#007AFF] to-[#5856D6] rounded-3xl flex items-center justify-center mb-6" }, [
                    _createElementVNode("i", { class: "ri-handshake-line text-white !text-[48px]" })
                  ], -1)),
                  _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.directT('crm.deals.noDealsFound')), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("table", _hoisted_20, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", _hoisted_21, [
                          _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.directT('crm.deals.id')), 1),
                          _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.directT('crm.deals.title')), 1),
                          _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.directT('crm.deals.contactPerson')), 1),
                          _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.directT('crm.deals.amount')), 1),
                          _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.directT('crm.deals.createdAt')), 1),
                          _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.directT('crm.deals.status')), 1),
                          _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.directT('crm.deals.action')), 1)
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredDeals, (deal) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: deal.id,
                            class: "bg-white dark:bg-[#1a1a1a] border-b border-[#E5E7EB] dark:border-[#374151] hover:bg-[#F0F7FF] dark:hover:bg-[#2a2a2a] transition-all duration-200"
                          }, [
                            _createElementVNode("td", _hoisted_29, [
                              _createElementVNode("div", _hoisted_30, [
                                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "w-10 h-10 bg-gradient-to-br from-[#007AFF] to-[#5856D6] rounded-2xl flex items-center justify-center mr-3" }, [
                                  _createElementVNode("i", { class: "ri-file-text-line text-white text-lg" })
                                ], -1)),
                                _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.shortId(deal.id)), 1)
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, _toDisplayString(deal.title), 1),
                              (deal.description)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(deal.description), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_35, [
                              _createElementVNode("div", _hoisted_36, _toDisplayString(deal.first_name && deal.last_name ? `${deal.first_name} ${deal.last_name}` : (deal.name || _ctx.directT('crm.deals.notDefined'))), 1),
                              (deal.phone)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(deal.phone), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_38, [
                              _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.formatCurrency(deal.amount)), 1)
                            ]),
                            _createElementVNode("td", _hoisted_40, [
                              _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.formatDate(deal.created_at)), 1)
                            ]),
                            _createElementVNode("td", _hoisted_42, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["px-3 py-1 rounded-xl font-medium text-sm border", _ctx.getStatusClass(deal.status)])
                              }, _toDisplayString(_ctx.getStatusText(deal.status)), 3)
                            ]),
                            _createElementVNode("td", _hoisted_43, [
                              _createElementVNode("div", _hoisted_44, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "p-2 rounded-xl bg-[#007AFF]/10 text-[#007AFF] hover:bg-[#007AFF]/20 transition-all duration-200",
                                  title: _ctx.directT('crm.deals.view'),
                                  onClick: ($event: any) => (_ctx.viewDeal(deal.id))
                                }, _cache[8] || (_cache[8] = [
                                  _createElementVNode("i", { class: "ri-eye-line text-lg" }, null, -1)
                                ]), 8, _hoisted_45),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "p-2 rounded-xl bg-[#34C759]/10 text-[#34C759] hover:bg-[#34C759]/20 transition-all duration-200",
                                  title: _ctx.directT('crm.deals.edit'),
                                  onClick: ($event: any) => (_ctx.editDeal(deal.id))
                                }, _cache[9] || (_cache[9] = [
                                  _createElementVNode("i", { class: "ri-edit-line text-lg" }, null, -1)
                                ]), 8, _hoisted_46),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "p-2 rounded-xl bg-[#FF3B30]/10 text-[#FF3B30] hover:bg-[#FF3B30]/20 transition-all duration-200",
                                  title: _ctx.directT('crm.deals.delete'),
                                  onClick: ($event: any) => (_ctx.confirmDeleteDeal(deal.id))
                                }, _cache[10] || (_cache[10] = [
                                  _createElementVNode("i", { class: "ri-delete-bin-line text-lg" }, null, -1)
                                ]), 8, _hoisted_47)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createVNode(_component_Pagination, {
                      items: 10,
                      total: 36,
                      class: "px-6 py-4"
                    })
                  ])
                ]))
        ])
      ])
    ]),
    (_ctx.showDeletePopup)
      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "w-12 h-12 bg-white/20 rounded-2xl flex items-center justify-center" }, [
                  _createElementVNode("i", { class: "ri-delete-bin-line text-white text-xl" })
                ], -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("h3", _hoisted_53, _toDisplayString(_ctx.directT('crm.deals.deleteConfirmTitle')), 1),
                  _createElementVNode("p", _hoisted_54, _toDisplayString(_ctx.directT('crm.deals.deleteConfirmSubtitle')), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("p", _hoisted_56, _toDisplayString(_ctx.directT('crm.deals.deleteConfirmMessage')), 1),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelDelete && _ctx.cancelDelete(...args))),
                  class: "flex-1 px-4 py-3 bg-[#F3F4F6] dark:bg-[#374151] text-[#1a1a1a] dark:text-white font-medium rounded-2xl transition-all duration-200 hover:bg-[#E5E7EB] dark:hover:bg-[#4B5563]"
                }, _toDisplayString(_ctx.directT('crm.deals.cancel')), 1),
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args))),
                  class: "flex-1 px-4 py-3 bg-gradient-to-r from-[#FF3B30] to-[#FF2D92] text-white font-medium rounded-2xl transition-all duration-200 hover:from-[#E6342A] hover:to-[#E6297D] shadow-lg"
                }, _toDisplayString(_ctx.directT('crm.deals.delete')), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}